<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M10.345 5.019c.727 0 1.316-.62 1.316-1.385 0-.764-.59-1.384-1.316-1.384-.726 0-1.315.62-1.315 1.384 0 .765.59 1.385 1.316 1.385Zm-.38 7.613a2.35 2.35 0 0 1-2.32 2.01 2.356 2.356 0 0 1-2.352-2.353c0-.966.585-1.795 1.419-2.158l.14-1.203a3.456 3.456 0 0 0 .794 6.822c1.794 0 3.252-1.37 3.427-3.118H9.965Z"/>
    <path d="M12.838 9.865c.358 0 .657.273.69.629l.345 3.807-1.379.126-.29-3.178H9.93l-1.176-.002a.692.692 0 0 1-.688-.773l.395-3.378H7.387a.415.415 0 0 0-.413.367l-.104.892-1.376-.16.104-.893a1.8 1.8 0 0 1 1.789-1.59h3.028a.691.691 0 0 1 .688.772l-.396 3.38h2.13Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
